import React, { useEffect } from 'react'
import Navigation from '../../../Components/Navigation/Navigation'
import Footer from '../../../Components/Footer/Footer'
import Hero from './Sections/Hero/Hero'
import IndustryChallengesAndSolutions from './Sections/IndustryChallengesAndSolutions/IndustryChallengesAndSolutions'
import IndustryTech from './Sections/IndustryTech/IndustryTech'
import AISearch from './Sections/AISearch/AISearch'
import SpecializedServices from './Sections/SpecializedServices/SpecializedServices'
import WhyChoose from './Sections/WhyChoose/WhyChoose'
import FAQ from '../../../Components/FAQ/FAQ'
import Aos from 'aos'
import 'aos/dist/aos.css'
import d1 from '../../../assets/images/d1.png'
import d2 from '../../../assets/images/d2.png'
import d9 from '../../../assets/images/d9.png'
import ClientSpeak from '../../Home/Components/ClientSpeak'
import GetQuote from '../../../Components/GetQuote/GetQuote'
import Contect from '../../Home/Components/Contect'
import CaseStudies from '../../Home/Components/CaseStudies'

const Dating = () => {

	useEffect(() => {
		Aos.init({
			duration: 1000,
			once: true,
			offset: 100,
		});
	}, []);

	const homeContent = {
		title: 'Dating App Development',
		description: "Here's the thing about dating apps – they're supposed to help you find love, right? However, the net effect for most users gets worse over time. Many apps obsess over infinite swipes instead of forming real bonds. We build platforms designed to create genuine connections.",
		image: d1,
		breadcrumb: 'Dating',
		b: 'Build Something Better'
	}

	const industryChallengesAndSolutionsContent = {
		challengesTitle: 'The Toxic Problems Destroying Dating App Success',
		solutionsTitle: 'The Revolutionary Approach That Actually Creates Lasting Relationships',
		challenges: [
			{
				title: 'Your User Verification Is Fake Profile Heaven',
				description: 'Weak verification lets catfishes and scammers run wild, destroying trust and driving authentic users away.',
				icon: '/images/industries/dating/01.svg',
			},
			{
				title: 'Shallow Swiping Is Killing Real Connections',
				description: 'Photo-based swiping reduces people to split-second judgments, ignoring compatibility that fuels lasting relationships.',
				icon: '/images/industries/dating/02.svg',
			},
			{
				title: 'Women Are Fleeing Due to Safety Concerns',
				description: 'Poor reporting and weak harassment prevention make women feel unsafe—half your user base leaves.',
				icon: '/images/industries/dating/03.svg',
			},
			{
				title: 'Your Algorithm Creates Addiction, Not Relationships',
				description: 'Engagement-first rankings trap users in endless scroll instead of helping them find meaningful matches.',
				icon: '/images/industries/dating/04.svg',
			},
			{
				title: 'Monetization Models That Punish Finding Love',
				description: 'Revenue tied to screen time creates perverse incentives where successful matches hurt the bottom line.',
				icon: '/images/industries/dating/05.svg',
			},
		],
		solutions: [
			{
				title: 'Identity Verification That Eliminates Catfishing',
				description: 'Multi-layer checks using government IDs, social links, and video verification ensure every profile is real.',
				icon: '/images/industries/dating/06.svg',
			},
			{
				title: 'Deep Compatibility Matching Beyond Photos',
				description: 'Advanced personality assessments and lifestyle signals match for long-term compatibility—not just attraction.',
				icon: '/images/industries/dating/07.svg',
			},
			{
				title: 'Safety Features That Protect Vulnerable Users',
				description: 'Real-time AI monitoring, instant block/report, and optional background checks foster safe engagement.',
				icon: '/images/industries/dating/08.svg',
			},
			{
				title: 'Algorithms Designed to Get Users Off the App',
				description: 'Ranking favors quality over time-on-app; success means users delete the app because they found love.',
				icon: '/images/industries/dating/09.svg',
			},
			{
				title: 'Revenue Models That Reward Real Connections',
				description: 'Subscriptions with success bonuses and milestone rewards align business outcomes with user happiness.',
				icon: '/images/industries/dating/10.svg',
			},
		]
	}

	const industryTechContent = {
		mainTitle: 'The Future-Gen Technology Re-Inventing Online Dating',
		leftHeading: 'Harnessing Advanced Technologies For Dating App Development',
		leftParagraph: 'We combine AI personality modeling, secure video verification, behavioral analytics, and privacy-first geolocation to build trustworthy platforms that foster real connections.',
		leftImage: d2,
		performanceItems: [
			{
				title: 'AI Personality & Compatibility Matching',
				description: 'Models analyze communication patterns, values, and lifestyle preferences to match beyond surface-level attraction.',
				icon: '/images/industries/dating/12.svg',
			},
			{
				title: 'Video Verification & Live Interaction',
				description: 'Seamless video verification and high-quality in-app calls let users connect authentically before meeting.',
				icon: '/images/industries/dating/13.svg',
			},
			{
				title: 'Behavioral Analytics for Connection Insights',
				description: 'Identify genuine interest patterns and improve match quality with privacy-respecting analytics.',
						icon: '/images/industries/dating/14.svg',
			},
			{
				title: 'Geolocation with Advanced Privacy Controls',
				description: 'Precise location matching with granular control over visibility and radius to protect users.',
				icon: '/images/industries/dating/15.svg',
			},
		]
	};

	const aiSearchContent = {
		mainTitle: 'The Complete Dating Platform That Actually Works',
		sections: [
			{
				title: 'Smart Matching Algorithm Engine',
				description: "AI that understands values, communication style, and relationship goals—matching for long-term success, not just shared pizza preferences.",
				image: '/images/industries/dating/d3.png',
				imageAlt: 'Smart Matching Algorithm Engine',
				imagePosition: 'left',
				features: [
					'Deep personality assessments beyond cliches',
					'Models improve whenever matches succeed',
					'Compatibility scores tied to long-term outcomes',
					'Smart filters that avoid obvious mismatches',
					'Feedback from real couples informs updates',
					'Lifestyle data integration for better fit',
				],
			},
			{
				title: 'Video Chat & Virtual Date Features',
				description: 'See chemistry before meeting. Real-time video chat, shared experiences, and guided interactions reduce wasted time.',
				image: '/images/industries/dating/d4.png',
				imageAlt: 'Video Chat & Virtual Date Features',
				imagePosition: 'right',
				features: [
					'Integrated HD video calling inside the app',
					'Virtual date templates and conversation starters',
					'Screen sharing for co-watching experiences',
					'Background blur and lighting filters',
					'Calendar integration and reminders',
					'In-call video verification for authenticity',
				],
			},
			{
				title: 'Safety & Reporting Management System',
				description: 'Practical safety that works: real-time AI, rapid moderation, and tools that stop repeat offenders.',
				image: '/images/industries/dating/d5.png',
				imageAlt: 'Safety & Reporting Management System',
				imagePosition: 'left',
				features: [
					'AI monitoring for harassment and abuse',
					'One-tap reporting with fast human review',
					'Device/account bans to block evasion',
					'Optional background checks for added trust',
					'Emergency contact alerts for first meetups',
					'24/7 safety support trained for dating issues',
				],
			},
			{
				title: 'User Verification & Profile Authentication',
				description: 'Multi-layer verification that stops catfishing before it starts, ensuring real people behind every profile.',
				image: '/images/industries/dating/d6.png',
				imageAlt: 'User Verification & Profile Authentication',
				imagePosition: 'right',
				features: [
					'Government ID with live document checks',
					'Social media cross-referencing',
					'Live video selfie verification',
					'Phone verification via SMS/voice',
					'Professional photo review for fakes',
					'Continuous monitoring for suspicious behavior',
				],
			},
			{
				title: 'Advanced Privacy & Security Controls',
				description: 'Enterprise-grade security with user-first privacy controls for data, profile visibility, and location.',
				image: '/images/industries/dating/d7.png',
				imageAlt: 'Advanced Privacy & Security Controls',
				imagePosition: 'left',
				features: [
					'Granular profile visibility controls',
					'End-to-end encrypted messages and calls',
					'Anonymous browsing modes',
					'Complete data deletion on request',
					'Adjustable location radius and controls',
					'2FA and biometric login options',
				],
			},
			{
				title: 'Relationship Success Tracking Dashboard',
				description: 'We measure what matters—real relationships formed—and use outcomes to improve matching for everyone.',
				image: '/images/industries/dating/d3.png',
				imageAlt: 'Relationship Success Tracking Dashboard',
				imagePosition: 'right',
				features: [
					'Live metrics on successful matches and couples',
					'Milestone tracking and long-term satisfaction',
					'Algorithm tuning based on conversion to dates',
					'Quality-weighted engagement metrics',
					'Longevity analytics to learn what lasts',
					'Success stories that improve future matching',
				],
			},
		],
	};

	const servicesContent = {
		title: 'The Development Expertise That Creates Love Stories',
		cards: [
			{
				icon: '/images/industries/dating/16.svg',
				title: 'Custom Matching Algorithm Development',
				description: 'Proprietary AI that analyzes deep compatibility factors to create matches with real relationship potential.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/dating/17.svg',
				title: 'Real-Time Video & Audio Integration',
				description: 'Seamless video chat and calling features that work flawlessly across devices and platforms.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/dating/18.svg',
				title: 'Advanced User Safety Systems',
				description: 'Comprehensive protocols: real-time monitoring, verification layers, and instant reporting mechanisms.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/dating/19.svg',
				title: 'Cross-Platform Mobile Development',
				description: 'Native iOS and Android with consistent UX and optimized performance end-to-end.',
				buttonText: 'Discover More',
			},
			{
						icon: '/images/industries/dating/20.svg',
				title: 'Privacy-First Architecture Design',
				description: 'Secure infrastructure with E2E encryption, granular controls, and user-owned data.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/petcare/16.svg',
				title: 'Behavioral Analytics & Machine Learning',
				description: 'Intelligent systems that learn from interactions to continuously improve match accuracy.',
				buttonText: 'Discover More',
			},
		],
	};

	const whyChooseContent = {
		title: 'Why Successful Dating Platforms Trust Our Development Team',
		image: d9,
		imageAlt: 'Why Choose Us for Dating App Development',
		items: [
			{
				title: 'Deep Understanding of Dating Psychology',
				desc: 'We study relationship science to build features that truly create connections.',
			},
			{
				title: 'Apps Built for User Safety First',
				desc: 'Every feature prioritizes protection and creates secure environments for everyone.',
			},
			{
				title: 'Privacy Standards That Build Trust',
				desc: 'Enterprise-level security keeps personal data private and fully controlled by users.',
			},
			{
				title: 'Scalable Architectures to Support Growth',
				desc: 'Infrastructure grows seamlessly with your user base without performance issues.',
			},
			{
				title: 'Developers Who Care About Real Outcomes',
				desc: 'We measure success by relationships formed—not just downloads or screen time.',
			},
		],
	};

	const faqContent = {
		title: 'Got Questions? We\'ve Got Answers',
		questions: [
			{
				q: 'How do you ensure our app creates real relationships, not just engagement?',
				a: 'We optimize for match quality and real outcomes; engagement is a secondary signal, not the goal.'
			},
			{
				q: 'What protection can you take to guard the users?',
				a: 'Advanced safety systems: real-time monitoring, instant reporting, background checks, and 24/7 moderation.'
			},
			{
				q: 'What is your user privacy and data protection?',
				a: 'End-to-end encryption, granular privacy controls, and enterprise security give users full data control.'
			},
			{
				q: 'How do you minimize catfishing and fake profiles?',
				a: 'Multi-layer verification—government ID, social cross-referencing, live video, and continuous monitoring.'
			}
		]
	};

	return (
		<>
			<Navigation offer={true} />
			<Hero homeContent={homeContent} />
			<div data-aos="fade-up">
				<IndustryChallengesAndSolutions industryChallengesAndSolutionsContent={industryChallengesAndSolutionsContent} />
			</div>
			<div data-aos="fade-up">
				<IndustryTech industryTechContent={industryTechContent} />
			</div>
			<div data-aos="fade-up">
				<AISearch aiSearchContent={aiSearchContent} />
			</div>
			<div data-aos="fade-up">
				<SpecializedServices servicesContent={servicesContent} />
			</div>
			<div data-aos="fade-up">
				<WhyChoose whyChooseContent={whyChooseContent} />
			</div>
			<div data-aos="fade-up">
				<CaseStudies />
			</div>
			<div data-aos="fade-up">
				<ClientSpeak />
			</div>
			<div data-aos="fade-up">
				<GetQuote />
			</div>
			<div data-aos="fade-up">
				<FAQ faqContent={faqContent} />
			</div>
			<div data-aos="fade-up">
				<Contect />
			</div>
			<Footer />
		</>
	)
}

export default Dating


